<template>
    <div id="archive_page" class="container-fluid">
        <v-client-table :data="tableData" :columns="columns" :options="options" @pagination="updateTooltips" @filter="updateTooltips" @sorted="updateTooltips">
            <template v-for="column in columns" :slot="column" slot-scope="props">
                <template v-if="column=='title'">
                    <div class="archive-name" :class="'row_'+props.row['archive_id']">
                        <span :class="'row_'+props.row['archive_id']">{{props.row[column]}}</span>
                        <span class="edit-name" @click="archiveEdit(props.row)"><img class="pencil-icon" :src="$store.state.app_url+'/images/data_sources/button_icons/pencil.svg'"></span>
                    </div>
                    <div class="edit-archive hidden" :class="'row_'+props.row['archive_id']">
                        <input v-model="edit_name" />
                        <span class="edit-name" @click="archiveSave(props.row)"><img class="check-icon" :src="$store.state.app_url+'/images/data_sources/button_icons/check.svg'"></span>
                    </div>
                </template>
                <template v-else>
                    <span>{{props.row[column]}}</span>
                </template>
            </template>
            <div slot="actions_kbp" slot-scope="props" class="text-right">
                <template v-if="props.row.is_ga4 > 0">
                    <router-link class="btn btn-info reverse" :to="{ path: '/reporting/archive/skb/' + props.row.archive_id}" target='_blank'>View KBPG</router-link>
                    <button @click="copyLink(props.row.signed_link_skb)" :title="props.row.signed_link" class="btn btn-info reverse btn-icon">
                        <i class="fa fa-copy" aria-hidden="true"></i>
                    </button>
                </template>
            </div>
            <div slot="actions_default" slot-scope="props" class="text-right">
                <router-link class="btn btn-info reverse" :to="{ path: '/reporting/archive/' + props.row.archive_id}" target='_blank'>View</router-link>
                <button @click="copyLink(props.row.signed_link)" :title="props.row.signed_link" class="btn btn-info reverse btn-icon">
                    <i class="fa fa-copy" aria-hidden="true"></i>
                </button>
                <button v-if="getUserPermissions().delete_archive" @click="remove(props.row.archive_id)" class="btn btn-danger reverse btn-icon">
                    <i class="fa fa-trash-o" aria-hidden="true"></i>
                </button>
            </div>
        </v-client-table>
        <input class='far-away' id="copy_signed_link" value="" ref="signed_link" />
    </div>
</template>

<script>
    export default {
        created() {
            this.fetchServerData();
        },
        data() {
            return {
                data_connection_accounts: {},
                data_sources_and_accounts:{},
                hasClientsConnected:false,
                edit_name:null,
                columns: ['title', 'client_name', 'creator', 'date_range', 'updated', 'actions_kbp', 'actions_default'],
                tableData: [],
                options: {
                    headings: {
                        title:       'Archive Name',
                        //name:        'Report Name',
                        client_name: 'Client Name',
                        creator:     'Created By',
                        date_range:  'Date Range',
                        updated:     'Updated',
                        actions_kbp:     'KBP Groupings',
                        actions_default: 'Default Groupings',
                    },
                    sortable: ['title', 'client_name', 'creator', 'date_range', 'updated'],

                    perPage: 20,
                    perPageValues: [],
                    texts: {
                        count: 'Showing {from} to {to} of {count} reports|{count} reports|One report',
                        filter: '',
                        filterPlaceholder: 'Search reports...',
                        noResults: 'No matching reports'
                    },
                    skin: 'table',
                    classes: {
                        'actions_kbp': 'text-right',
                        'actions_default': 'text-right'
                    }
                }
            }
        },
        methods: {
            fetchServerData() {
                axios.all([
                    axios.get(`/api/archive?client_id=${this.$route.params.client_id || ''}`),
                    axios.get('/api/data-connections/reports'),
                    axios.get('/api/clients/connected'),
                    axios.get('/api/reports/data-sources-and-accounts')
                ])
                    .then(axios.spread((reports, dataConnectionAccounts, clientsConnected, dataSourcesAndAccounts) => {
                        this.tableData                 = reports.data;
                        this.data_connection_accounts  = dataConnectionAccounts.data.data;
                        this.hasClientsConnected       = clientsConnected.data > 0;
                        this.data_sources_and_accounts = dataSourcesAndAccounts.data;

                        this.updateTooltips();
                    }));
            },
            archiveEdit(row){
                const id = row.archive_id;
                const $this = $('.archive-name.row_'+id);
                if(!$this.hasClass('editing')){
                    this.edit_name = $('span.row_'+id).text();
                    $('div.archive-name.row_'+id).addClass('hidden');
                    $('div.edit-archive.row_'+id).removeClass('hidden');
                    $('div.archive-name').addClass('editing');
                }
            },
            archiveSave(row){
                const id = row.archive_id;
                const $this = $('.archive-name.row_'+id);
                axios.post('/api/archive/rename', {'archive_id':id, 'archive_name':this.edit_name}).then((response) => {
                    $('.archive-name.row_'+id).removeClass('hidden');
                    $('.edit-archive.row_'+id).addClass('hidden');
                    $('.archive-name').removeClass('editing');
                    $('span.row_'+id).text(this.edit_name);
                    this.edit_name = null;
                });
            },
            createTooltip(archiveId, dataSourceName) {
                let tooltip = `<table style="font-size:1.28rem" class="table table-borderless table-sm table-tooltip"><thead><tr><td>Source Name</td><td>Account Name</td></tr></thead><tbody>`;

                _.each(this.data_connection_accounts[archiveId][dataSourceName], account => {
                    tooltip += `<tr><td>${account.name_given_by_user}</td><td>${account.primary_name_in_source || ''} (${account.primary_account_id || ''})</td></tr>`;
                });

                tooltip += '</tbody></table>';

                return tooltip;
            },
            updateTooltips() {
                setTimeout(() => {
                    $('#reports_page').find('.sources img').each(function() {
                        if ($(this).hasClass('tooltipstered')) {
                            $(this).tooltipster('destroy');
                        }
                    });

                    $('#reports_page').find('.sources img').tooltipster({
                        contentAsHTML:     true,
                        animation:         false,
                        animationDuration: false,
                        interactive:       true,
                        side:              'bottom'
                    });
                }, 0);
            },
            remove(archiveId) {
                this.confirmation(this.messages.WARNING_ARCHIVE_DELETE, () => {
                    axios.delete(`/api/archive/${archiveId}`).then(response => {
                        this.fetchServerData();

                        this.$notify({
                            type: 'success',
                            text: this.messages.ARCHIVE_DELETED
                        });
                    });
                });
            },
            copyLink(signed_link){
                $('input#copy_signed_link').val(signed_link);
                let Url = this.$refs.signed_link;
                Url.select();
                document.execCommand("copy");
            }
        }
    }
</script>

<style lang="scss">
    #archive_page {
        .fa-trash-o,
        .fa-refresh {
            font-size: 1.4rem;
            padding: .1rem;
        }
        .fa-copy {
            font-size: 1.6rem;
        }
        .sources {
            img {
                max-height: 3.2rem;
            }
        }

        button:disabled, a.disabled {
            pointer-events: initial !important;
            cursor: not-allowed;

            &:hover{
                color:white;
            }
        }
        span.edit-name{
            margin-left:0.5rem;
            img{
                margin-top:-0.2rem;
                cursor:pointer;
            }
        }
        div.archive-name{
            display:flex;
            justify-content:space-between;
            &.editing{
                img.pencil-icon{
                    cursor:not-allowed;
                }
            }
        }

        .check-icon {
            height: 1.6rem;
        }
    }
    input.far-away{
        position:fixed;
        top:99999rem;
        left:99999rem;
    }
    th:nth-child(6), th:nth-child(7){
        text-align: right;
    }
</style>
